module.exports = __webpack_public_path__ + "img/sport-video-thumb.84a44499.png";